<template>
  <div>
    <div class="app-showcase-process-step__one mb-40">
      <div class="container-fluid container-fluid--cp-150">
        <div class="row align-items-center">
          <div class="col-lg-5 col-md-5">
            <div class="app-showcase-process-step__media text-center wow move-up">
              <img :src="img" class="img-fluid" alt="thumbnail" />
            </div>
          </div>
          <div class="col-lg-7 col-md-7">
            <div class="app-showcase-process-step__content section-space--mt_40">
              <div class="app-showcase__inner">
                <h4 class="font-weight--light wow move-up">{{ title }}</h4>
                <div class="sub-text section-space--mb_40 wow move-up">
                  {{ desc }}
                </div>
                <div class="sub__title mb-20 wow move-up">
                  <h6 class="font-weight--blod">{{ subtitle }}</h6>
                </div>
                <div class="sub-text section-space--mb_20 wow move-up">
                  {{ info }}
                </div>
                <div class="wow move-up">
                  <b-form @submit.prevent="onSubmit" @reset="onReset" v-if="show">
                    <b-form-group id="input-group-1" label="Verification Code:" label-for="input-1">
                      <b-form-input
                        id="input-1"
                        v-model="form.code"
                        type="text"
                        placeholder=""
                        required
                        class="form-input"
                      ></b-form-input>
                    </b-form-group>

                    <div v-if="this.error" class="alert alert-danger" role="alert">
                      Code is invalid. Please try again.
                    </div>

                    <div class="btn-sowcase section-space--mb_40 wow move-up">
                      <b-button type="submit" variant="primary" class="scroll btn btn--green"
                        >Next</b-button
                      >
                    </div>

                    <div>
                      <a
                        href="#"
                        class="hover-style-link hover-style-link--green"
                        @click="onResendEmail"
                        >Resend Verification Email</a
                      >
                    </div>
                    <div>
                      <p>
                        Already verified?
                        <a href="/login" class="hover-style-link hover-style-link--green">Log In</a>
                      </p>
                    </div>

                    <!-- testing -->
                    <!-- <b-button type="reset" variant="danger">Reset</b-button> -->
                  </b-form>
                  <!-- <b-card class="mt-3" header="Form Data Result">
                                <pre class="m-0">{{ form }}</pre>
                                </b-card> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <FooterMain FooterStyle="bg_drak-footer" />
  </div>
</template>

<script>
import axios from 'axios'

import FooterMain from '@/components/FooterMain'

import { handleGlobalError } from '../util'
export default {
  name: 'VerifyEmail',
  components: {
    FooterMain,
  },
  data() {
    return {
      img: require('../assets/img/hero/startup/top.png'),
      subtitle: 'Verify Email Address',
      title: 'The fun begins with a Pixel Profile!',
      desc: 'A Pixel Profile is required in order to play some Pixel games (including the PixelDebates trading card game).  Your profile is where you can deposit $PXL for instant and feeless use in our games.',
      info: 'A verification email has been sent to the email address you provided.  Please enter the code before proceeding.',
      form: {
        code: '',
      },
      show: true,
      error: false,
    }
  },
  async mounted() {
    if (this.$store.getters.user && this.$store.getters.user.isVerified) {
      this.$router.push('/profile')
    } else if (this.$store.getters.user) {
      // double check to see if they verified via the email link
      this.getCurrentUser()
      this.startCheckingIsVerified()
    }
  },
  computed: {
    email() {
      return this.$route.query.email
    },
  },
  methods: {
    async onSubmit() {
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/authmanagement`, {
          action: 'verifySignupShort',
          value: {
            user: { email: this.email },
            token: this.form.code,
          },
        })
        this.stopCheckingIsVerified()
        // if we have a logged in user, update them and go to the profile
        if (this.$store.getters.user) {
          this.$store.commit('updateUser', { isVerified: true })
          this.$router.push({ path: `profile` })
        } else {
          this.$router.push({ path: `verify-success` })
        }
      } catch (error) {
        this.loading = false
        if (
          error.response &&
          error.response.status === 400 &&
          error.response.data &&
          error.response.data.message === 'User is already verified & not awaiting changes.'
        ) {
          this.$router.push({ path: `verify-success` })
        } else {
          console.error('token is invalid', error.response)
          handleGlobalError(this, error, 'validate token. Token is invalid')
        }
      }
    },
    onReset(event) {
      event.preventDefault()
      // Reset  form values
      this.form.code = ''
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.$nextTick(() => {
        this.show = true
      })
    },
    async getCurrentUser() {
      try {
        const updatedUser = await axios.get(
          `${process.env.VUE_APP_PXL_API}/users/${this.$store.getters.user.id}`
        )
        if (updatedUser && updatedUser.data && updatedUser.data.isVerified) {
          this.stopCheckingIsVerified()
          // if we have a logged in user, update them and go to the profile
          if (this.$store.getters.user) {
            this.$store.commit('updateUser', { isVerified: true })
            this.$router.push({ path: `profile` })
          } else {
            this.$router.push({ path: `verify-success` })
          }
        }
      } catch (error) {
        this.stopCheckingIsVerified()
        this.loading = false
        console.error('checking verification', error)
        handleGlobalError(this, error, 'checking verification')
      }
    },
    async onResendEmail() {
      try {
        await axios.post(`${process.env.VUE_APP_PXL_API}/authmanagement`, {
          action: 'resendVerifySignup',
          value: {
            email: this.email,
          },
        })
        this.$bvToast.toast('Email has been re-sent!', {
          title: 'Success',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
        })
      } catch (error) {
        this.loading = false
        console.error('resend email invalid', error)
        handleGlobalError(this, error, 'validate token. Token is invalid')
      }
    },
    /**
     * start regularly checking to see if the user verified their email via the email link
     */
    startCheckingIsVerified() {
      if (this.checkingIsVerified) {
        return
      }
      this.checkingIsVerified = setInterval(this.getCurrentUser, 10000)
    },
    stopCheckingIsVerified() {
      if (this.checkingIsVerified) {
        clearInterval(this.checkingIsVerified)
      }
    },
  },
}
</script>
